import "core-js/modules/es.function.name.js";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getLocaleId } from "@faire/help-center-utils/serialized-data/getLocale";
import { getRetailer, getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getUser, getUserEmail, getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
export var useChatbotStaticMetadata = function useChatbotStaticMetadata() {
  var _retailer$name, _getUser, _getUser2, _getUserToken;
  var retailer = getRetailer();
  var brand = getBrand();
  var businessName = (_retailer$name = retailer === null || retailer === void 0 ? void 0 : retailer.name) !== null && _retailer$name !== void 0 ? _retailer$name : brand === null || brand === void 0 ? void 0 : brand.name;
  var brandEmail = brand === null || brand === void 0 ? void 0 : brand.email_address;
  var retailerEmail = retailer === null || retailer === void 0 ? void 0 : retailer.email_address;
  var firstName = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.first_name;
  var lastName = (_getUser2 = getUser()) === null || _getUser2 === void 0 ? void 0 : _getUser2.last_name;
  var userEmail = getUserEmail();
  var userType = getRetailerToken() ? "retailer" : "brand";
  var locale = getLocaleId(); // fr_FR for example
  return {
    user_token: (_getUserToken = getUserToken()) !== null && _getUserToken !== void 0 ? _getUserToken : "",
    first_name: firstName !== null && firstName !== void 0 ? firstName : "",
    last_name: lastName !== null && lastName !== void 0 ? lastName : "",
    email: userEmail,
    retailer_token: retailer === null || retailer === void 0 ? void 0 : retailer.token,
    brand_token: brand === null || brand === void 0 ? void 0 : brand.token,
    business_name: businessName,
    retailer_email: retailerEmail,
    brand_email: brandEmail,
    user_type: userType,
    locale: locale !== null && locale !== void 0 ? locale : ""
  };
};